module.exports = __webpack_public_path__ + "static/media/user-outlined.48738a2a.svg";